<app-chat-and-shop-button [shopUrl]="shopUrl" [pharmacy]="pharmacy$ | async"></app-chat-and-shop-button>
